import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export const JULIA_PROJECT_HEADER = 'X-Julia-Project';

/**
 * Tells Julia which project the request belongs to: one Julia deployment serves several
 * platforms and rejects (400) a request that does not name its project.
 *
 * Only calls to Julia (URLs starting with `juliaApiUrl`) carry the header; the eNegoce
 * backend and third-party services never see it. Values come from the runtime config.
 */
@Injectable()
export class JuliaProjectInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const juliaUrl = environment.juliaApiUrl;
    const project = environment.juliaProject;
    if (!juliaUrl || !project || !request.url.startsWith(juliaUrl)) {
      return next.handle(request);
    }
    return next.handle(request.clone({
      headers: request.headers.set(JULIA_PROJECT_HEADER, project),
    }));
  }
}
